<template>
  <div>
    <app-header />
    <el-button type="primary" icon="el-icon-download" @click="indivi()" size="small" style="position: absolute;right: 30px;top:100px;z-index: 9;">pdf报告下载</el-button>
    <div class="pdfbox2_20" id="pdfDom">
      <div class="pdfhead2_20" style="margin-top: 60px;">
        <img src="../assets/img/LOGO2_20.png" alt="" class="img">
        <span>医学生物特征认知专家</span>
      </div>
      <div class="pdftitle2_20">
        <div class="pdftitlename2_20">{{msg.name}}报告</div>
        <div class="pdftitlenameps2_20">（{{msg.dateCreate}}）</div>
      </div>
      <div class="pdfbianma2_20">
        <span>用户编码：{{info.id}}</span>
        <span>管理层级：{{info.dept.deptName}}</span>
      </div>
      <div class="userps2_20">
        <div class="uluserps2_20">
          <div class="li">姓名：{{info.userName}}</div>
          <div class="li">性别：{{info.sex==1?'男':'女'}}</div>
          <div class="li">年龄：{{info.remark}}</div>
        </div>
        <div class="uluserps2_20">
          <div class="li">身高：{{info.userHeight}}cm</div>
          <div class="li">体重：{{info.userWeight}}kg</div>
          <div class="li">生日：{{info.birthday}}</div>
        </div>
        <div class="uluserps2_20">
          <div class="li">手机：{{info.phone==''?'--':info.phone}}</div>
          <div class="li">实名认证：{{num==null?"未实名":'已实名认证'}}</div>
          <div class="li">身份证号：{{num==null?"--":num.cardId}}</div>
        </div>
        <div class="uluserps2_20">
          <div class="li">{{msg.name}}病史：{{msg.strokeHistory?msg.strokeHistory:'--'}}</div>
          <div class="li" style="padding-right:30px;overflow : hidden;text-overflow: ellipsis;white-space: nowrap;box-sizing: border-box;">过敏史：{{info.historyOfAllergy}}</div>
          <div class="li" v-if="info.sex==2">是否怀孕：{{info.gravida==2?'否':'是'}}</div>
        </div>
      </div>
      <div class="zhibaotitle2_20">指标检测分析</div>
      <div class="jiancexm2_20">1、检测项目</div>
      <div class="biage2_20">
        <div class="biaogeul2_20">
          <div class="biaogeli2_20" style="font-weight: bold;">
            <div class="li">检测项目</div>
            <div class="li">结果</div>
            <div class="li">理想指标</div>
            <div class="li">单位</div>
          </div>
          <div class="biaogeli2_20" style="font-weight: bold;">
            <div class="li">检测项目</div>
            <div class="li">结果</div>
            <div class="li">理想指标</div>
            <div class="li">单位</div>
          </div>
          <div class="biaogeli2_20" style="border-bottom: 1px solid #000;border-top:none;border-right:none;width: 100%;">

           <div style="width: 100%;float: left;font-size: 16px;color: #999;text-align: center; margin:30px 0;" v-if="!msg.monitoringData">暂无数据！</div>
            <div v-for="(val,index) in msg.monitoringData" v-if="msg.monitoringData" class="youqian2_25">
              <div class="li" style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">{{val.testType}}</div>
              <div class="li">{{val.testValue}}</div>
              <div class="li" style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">{{val.idealIndex==null?'--':val.idealIndex}}</div>
              <div class="li">{{val.unit==null?'--':val.unit}}</div>
            </div>
          </div>
        </div>
        <!--        <div class="biaogeul2_20">
          <div class="biaogeli2_20" style="border-right:none;font-weight: bold;">
            <div class="li">检测项目</div>
            <div class="li">结果</div>
            <div class="li">单位</div>
          </div>
          <div class="biaogeli2_20" style="border-bottom: 1px solid #000;border-right:none;">
            <div v-for="(val,index) in msg.testDataList" v-if="index>msg.testDataList.length/2">
              <div class="li">{{val.testType}}</div>
              <div class="li">{{val.testValue}}</div>
              <div class="li">{{val.unit}}</div>
            </div>
          </div>
        </div> -->
        <div class="jiancexm2_20">2、一周内用药史</div>
        <div class="fuyao2_20">
          <div class="li">服药情况</div>
          <div class="li">服药记录</div>
        </div>
        <div class="fuyao12_20">
          <div style="width: 100%;float: left;font-size: 16px;color: #999;text-align: center; margin:30px 0;" v-if="!msg.weekMedication">暂无数据！</div>
          <div v-for="val in msg.weekMedication" v-if="msg.weekMedication">
            <div class="li">{{val.queName}}</div>
            <div class="li">{{val.queValue}}</div>
          </div>
        </div>
        <div class="zhibaotitle2_20">{{msg.name}}结果</div>
        <div class="pdftongjitu2_20">
          <div class="li">
            <div class="zhi" :style="{'color':msg.color}">{{msg.scoreStr}}</div>
            <div class="zhips">评估分值</div>
          </div>
          <div class="li" id="svgcan">
            <div class="tu">
              <el-progress :width='153' :stroke-width="15" type="circle" :percentage="msg.riskIndex == 0?'':msg.riskIndex" :color="msg.color" :show-text='false'></el-progress>
            </div>
            <div class="tuzhi" :style="{'color':msg.color}">{{msg.grade}}</div>
            <div class="tuzhips">风险等级</div>
          </div>
          <div class="li">
            <div class="zhi" :style="{'color':msg.color}">{{msg.riskIndexStr == '0%'?'暂无指数':msg.riskIndexStr}}</div>
            <div class="zhips" >风险指数</div>
          </div>
        </div>
        <div class="jieguo2_20">您的检测结果显示当前为：<span style="font-size: 16px;font-weight: bold;"><span :style="{'color':msg.color}">{{msg.grade}}人群</span></span></div>
        <div class="jieguo2_20" style="padding-top: 0;">{{msg.report[0].value}}</div>
        <div class="weixian2_20">
          <div class="jieguo2_20" style="padding: 10px 0;text-align: center;">您目前的主要危险因素检查结果及推荐理想目标</div>
          <div class="ul">
            <div class="li" style="font-weight: bold;">主要危险因素</div>
            <div class="li" style="font-weight: bold;">评测结果</div>
            <div class="li" style="font-weight: bold;">理想指标</div>
            <div class="li" style="font-weight: bold;">单位</div>
          </div>

         <div style="width: 100%;float: left;font-size: 16px;color: #999;text-align: center; margin:30px 0;" v-if="!msg.monitoringData">暂无数据！</div>
          <div class="ul" v-for="(val,index) in msg.monitoringData" v-if="val.overStandard==0">
            <div class="li">{{val.testType}}</div>
            <div class="li">{{val.testValue}}</div>
            <div class="li" style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">{{val.idealIndex==null?'--':val.idealIndex}}</div>
            <div class="li">{{val.unit==null?'--':val.unit}}</div>
          </div>
        </div>
        <div class="zhibaotitle2_20" style="margin-top: 20px;">健康处方及引导</div>
        <div class="pdfyindao2_20" v-for="val in msg.prescribe">
          <div class="pdfyindaotitle2_20">{{val.prescribeName}}</div>
          <div class="pdfyindaops2_20">{{val.prescribeMessage}}</div>
        </div>
        <div class="zhibaotitle2_20" style="margin-top: 20px;">结果分析</div>
        <div class="pdfyindao2_20" v-for="(val,index) in msg.report">
          <div v-if="index==0" style="width: 100%;float: left;height: 20px;"></div>
          <div class="pdfyindaotitle2_20" v-if="index!=0">{{val.name}}</div>
          <div class="pdfyindaops2_20">{{val.value}}</div>
        </div>
        <div class="dibu2_20" style="margin-top: 60px;"></div>
      </div>
      <div style="clear: both;"></div>
    </div>
    <div style="clear: both;"></div>
    <app-footer />
  </div>
</template>
<script>
import header from '@/components/header'
import footer from '@/components/footer'
import { request } from '@/network/request'
import $ from 'jquery'
import canvg from 'canvg'
import JsPDF from 'jspdf'
import html2Canvas from 'html2canvas'

export default {
  name: "",
  data() {
    return {
      msg: { report: [{}], },
      info: { dept: {} },
      num:{},


    }
  },
  beforeRouteLeave(to, from, next) { // 如果没有配置顶部按钮或isBounce,则beforeRouteLeave不用写
    let _this = this;

    if(to.fullPath == '/topic'){


      _this.$router.go(-1);


    }
next()
  },

  mounted: function() {
    let _this = this;
    if (sessionStorage.getItem('topic') == 0) {
      _this.baogaops1();
    } else {
      _this.baogaops();
    }
 _this.usershi();
    request({
      url: '/system/user/profile/userInfo',
      method: 'get',
      params: {}
    }).then(res => {
      if (res.data.code == 200) {
        _this.info = res.data.data;
        if (_this.info.historyOfAllergy == "" || _this.info.historyOfAllergy == undefined) {
          _this.info.historyOfAllergy = "无";
        } else {
          var text = "",
            historyOfAllergy = null;
          _this.info.historyOfAllergy = JSON.parse(_this.info.historyOfAllergy);

          console.log(historyOfAllergy)
          for (var s = 0; s < _this.info.historyOfAllergy.length; s++) {
            for (var i = 0; i < _this.info.historyOfAllergy[s].userAllergensList.length; i++) {
              if (_this.info.historyOfAllergy[s].userAllergensList[i].status == 1) {
                text += _this.info.historyOfAllergy[s].userAllergensList[i].name + " ";

              }

            }
            text += _this.info.historyOfAllergy[s].value;
          }

          _this.info.historyOfAllergy = text.substr(0,15)+'...';
        }
      } else {

      }

    })

  },
  components: {
    'app-header': header,
    'app-footer': footer,
  },
  methods: {
        usershi() {
      // console.log('submit!');
      let _this = this;
      request({
        url: '/professional/queryRealById',
        method: 'get',
        params: {
          /*'userId': sessionStorage.getItem("userId")*/
        }
      }).then(res => {

        if (res.data.code == 200) {

          _this.num = res.data.data;
        } else {

        }
      })
    },
    baogaops() {
      let _this = this;
      request({
        url: '/report/tWzaiDetailedReport/viewReports',
        method: 'get',
        params: { reportId: localStorage.getItem('baogaoid') }
      }).then(res => {
        if (res.data.code == 200) {
          _this.msg = res.data.data;


        } else {

        }

      })

    },
    baogaops1() {
      let _this = this;
      request({
        url: '/report/tWzaiDetailedReport/viewReport',
        method: 'get',
        params: { reportId: localStorage.getItem('baogaoid') }
      }).then(res => {
        if (res.data.code == 200) {
          _this.msg = res.data.data;


        } else {

        }

      })

    },
    indivi() {
      this.onclone();
    },
    // TODO:: SVG to canvas
    onclone() {
      let _this = this;
      const svgElems = $('#svgcan').find('svg');
      svgElems.each(function(index, node) {
        //获取svg的父节点
        var parentNode = node.parentNode;
        //获取svg的html代码
        var svg = node.outerHTML.trim();
        //创建一个<canvas>，用于放置转换后的元素
        var canvas = document.createElement('canvas');
        //将svg元素转换为canvas元素


        canvg(canvas, svg);
        canvas.style.height = '153px';
        canvas.style.position = 'absolute';
        canvas.style.left = '-76px';
        //删除svg元素
        parentNode.removeChild(node);
        //增加canvas元素
        parentNode.appendChild(canvas);
        _this.getPdf();
      });
    },
    getPdf() {

      var title = this.msg.name+'报告'; //this.title
      html2Canvas(document.querySelector('#pdfDom'), {
        allowTaint: true,
        scale: 1 // 提升画面质量，但是会增加文件大小
      }).then(function(canvas) {
        //  document.body.appendChild(canvas);
        // console.log(canvas)
        let contentWidth = canvas.width
        let contentHeight = canvas.height
        let pageHeight = contentWidth / 592.28 * 841.89
        let leftHeight = contentHeight
        let position = 0
        let imgWidth = 595.28
        let imgHeight = 592.28 / contentWidth * contentHeight
        let pageData = canvas.toDataURL('image/jpeg', 1.0)
        console.log(pageData)
        let PDF = new JsPDF('', 'pt', 'a4');
        if (leftHeight < pageHeight) {
          PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
        } else {
          while (leftHeight > 0) {
            PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
            leftHeight -= pageHeight
            position -= 841.89
            if (leftHeight > 0) {
              PDF.addPage()
            }
          }
        }
        PDF.save(title + '.pdf')
      })
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleClick(row) {
      console.log(row);
    },
    onSubmit() {
      console.log('submit!');
    }

  }
}

</script>
<style>
#svgcan {
  pointer-events: none;
}

.youqian2_25 {
  width: 50%;
  float: left;
  border-right: 1px solid #000;
}

.biaogeli2_20 .youqian2_25:nth-child(even) {
  border-right: none;
}

.pdfbox2_20 {
  width: 1200px;
  padding: 0 150px;
  box-sizing: border-box;
  background-color: #fff;
  /*float: left;*/
  margin: 60px auto;
}

.pdfhead2_20 {
  width: 100%;
  float: left;
  height: 54px;
  line-height: 54px;
  font-size: 14px;
  color: #C3C5C3;
  text-align: right;
  border-bottom: 5px solid #000;
}

.pdfhead2_20 .img {
  width: 98px;
  float: left;
  height: 24px;
  margin-top: 15px;
}

.pdftitle2_20 {
  width: 100%;
  padding: 20px 0;
  float: left;
  border-bottom: 5px solid #000;
}

.pdftitlename2_20 {
  width: 100%;
  float: left;
  font-size: 28px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000000;
  text-align: center;
}

.pdftitlenameps2_20 {
  width: 100%;
  float: left;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  margin-top: 16px;
  text-align: center;
}

.pdfbianma2_20 {
  width: 100%;
  padding: 10px 0;
  float: left;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;

}

.pdfbianma2_20 span:nth-child(1) {
  float: left;
}

.pdfbianma2_20 span:nth-child(2) {
  float: right;
}

.userps2_20 {
  width: 100%;
  padding: 0 30px;
  box-sizing: border-box;
  float: left;
  border: 1px solid #000;
}

.uluserps2_20 {
  width: 100%;
  height: 42px;
  line-height: 42px;
  float: left;
}

.uluserps2_20 .li {
  width: 33.3%;
  float: left;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
}

.zhibaotitle2_20 {
  width: 100%;
  float: left;
  height: 50px;
  line-height: 50px;
  padding: 0 30px;
  box-sizing: border-box;
  background: #F5F5F5;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000000;
  margin-top: 20px;
}

.jiancexm2_20 {
  width: 100%;
  float: left;
  height: 53px;
  line-height: 53px;
  padding: 0 30px;
  box-sizing: border-box;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  /* border-bottom: 1px solid #000;*/
}

.biage2_20 {
  width: 100%;
  float: left;
}

.biaogeul2_20 {
  width: 100%;
  float: left;
}

.biaogeli2_20 {
  width: 50%;
  float: left;
  border-right: 1px solid #000;
  border-top: 1px solid #000;
  border-bottom: 1px solid #000;
}

.biaogeli2_20 .li {
  width: 25%;
  height: 34px;
  line-height: 34px;
  float: left;
  text-align: center;
  font-size: 14px;
  font-family: Microsoft YaHei;
  color: #000000;

}

.fuyao2_20 {
  width: 100%;
  height: 34px;
  line-height: 34px;
  float: left;
  border-top: 1px solid #000;
  border-bottom: 1px solid #000;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000000;
}

.fuyao2_20 .li:nth-child(1) {
  width: 70%;
  float: left;
  padding: 0 30px;
  box-sizing: border-box;

}

.fuyao2_20 .li:nth-child(2) {
  width: 30%;
  float: left;
  padding: 0 30px;
  text-align: center;
  box-sizing: border-box;

}

.fuyao12_20 {
  width: 100%;

  float: left;
  border-bottom: 1px solid #000;
  font-size: 14px;
  font-family: Microsoft YaHei;
  color: #000000;
}

.fuyao12_20 .li:nth-child(odd) {
  width: 70%;
  float: left;
  padding: 0 30px;
  box-sizing: border-box;
  height: 30px;
  line-height: 30px;

}

.fuyao12_20 .li:nth-child(even) {
  width: 30%;
  height: 30px;
  line-height: 30px;
  float: left;
  padding: 0 30px;
  text-align: center;
  box-sizing: border-box;

}

.pdftongjitu2_20 {
  width: 100%;
  float: left;
}

.pdftongjitu2_20 .li {
  width: 33.3%;
  float: left;
  text-align: center;
  position: relative;
}

.pdftongjitu2_20 .li .zhi {
  width: 100%;
  float: left;
  text-align: center;
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #FF5429;
  margin-top: 74px;
}

.pdftongjitu2_20 .li .zhips {
  width: 100%;
  float: left;
  text-align: center;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  margin-top: 11px;
}

.pdftongjitu2_20 .li .tu {
  margin-top: 23px;
}

.pdftongjitu2_20 .li .tuzhi {
  width: 100%;
  position: absolute;
  left: 0;
  top: 74px;
  z-index: 999;
  text-align: center;
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #FF5429;
}

.pdftongjitu2_20 .li .tuzhips {
  width: 100%;
  position: absolute;
  left: 0;
  top: 113px;
  z-index: 999;
  text-align: center;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
}

.jieguo2_20 {
  width: 100%;
  float: left;
  padding: 20px 30px;
  box-sizing: border-box;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
}

.weixian2_20 {
  width: 100%;
  padding: 10px 0;
  float: left;
  border-top: 1px solid #000;
  border-bottom: 1px solid #000;
}

.weixian2_20 .ul {
  width: 100%;
  float: left;
  padding: 10px 0;
}

.weixian2_20 .ul .li {
  width: 25%;
  float: left;
  text-align: center;
  font-size: 14px;
  font-family: Microsoft YaHei;
  color: #000000;
}

.pdfyindao2_20 {
  width: 100%;
  float: left;
}

.pdfyindaotitle2_20 {
  width: 100%;
  float: left;
  padding: 20px 30px;
  box-sizing: border-box;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000000;
}

.pdfyindaops2_20 {
  width: 100%;
  float: left;
  padding: 0 30px;
  text-indent: 2em;
  box-sizing: border-box;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  line-height: 20px;
}

.dibu2_20 {
  width: 100%;
  height: 5px;
  float: left;
  margin: 20px 0;
  border-top: 5px solid #000;
  border-bottom: 1px solid #000;
  box-sizing: content-box;
}

</style>



// WEBPACK FOOTER //
// src/components/pdf.vue